import { useState } from 'react';
import PatchCenterDashboard from './patchCenter';
import Card from '../Card';
import Header from '../header';
import SelectDevice from './selectDevice';
import { useNavigate } from 'react-router-dom';

const Outbox = () => {
  const [activeTab, setActiveTab] = useState<'Explorer' | 'Availability' | 'Activity'>('Explorer');
  const [patchStatus, setPatchStatus] = useState(true);
  const [dropdownNum, setDropdownNum] = useState(0);

  const handleButtonClick = () => {
    setDropdownNum(1);
    setPatchStatus(false);
  };

  const navigate = useNavigate();

  const PatchNavigation = () => {
    navigate('/patchCenter/ActivityPatch');
  };
  const routeAvailability = () => {
    navigate('/patchCenter/AvailabilityPatch');
  };

  return (
    <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
      <Header title="Patch Center" dropdown={dropdownNum} handleButtonClick={handleButtonClick} />
      <div className="flex flex-1">
        <Card className="flex-1" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <div className="flex items-center justify-between mb-4">
            {/* Title */}
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
              {['Explorer', 'Availability', 'Activity'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => {
                    setActiveTab(tab as 'Explorer' | 'Availability' | 'Activity');
                    if (tab === 'Activity') {
                      PatchNavigation();
                    }
                    if (tab === 'Availability') {
                      routeAvailability();
                    }
                  }}
                  style={{
                    padding: '0.5rem 1rem',
                    borderRadius: '6px',
                    borderRight: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                    borderLeft: activeTab === tab ? '5.62px solid #D12929' : '5.62px solid #474646',
                    color: '#fff',
                    cursor: 'pointer',
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
            {patchStatus && (
              <div className="flex items-center gap-3 p-3">
                {/* From Date */}
                {/* <div className="flex items-center gap-2 px-3 py-2 border border-gray-600 rounded-lg text-white cursor-pointer bg-transparent">
                  <FaCalendarAlt className="text-gray-400" />
                  <span className="text-gray-400">Select Date</span>
                </div> */}

                {/* Filter Dropdown */}
                <div className="relative">
                  {/* <button
                    className="flex items-center gap-2 px-3 py-2 border border-gray-600 rounded-lg text-white cursor-pointer bg-transparent w-[120px] justify-between"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <FaFilter className="text-gray-400" />
                    <span className="text-gray-400">Filter</span>
                    <span className="text-gray-400">{showDropdown ? '▲' : '▼'}</span>
                  </button> */}

                  {/* Dropdown Menu */}
                  {/* {showDropdown && (
                    <div className="absolute mt-2 w-full bg-[#1F1F1F] border border-gray-600 rounded-lg text-white shadow-lg">
                      <div className="px-3 py-2 hover:bg-gray-700 cursor-pointer">Option 1</div>
                      <div className="px-3 py-2 hover:bg-gray-700 cursor-pointer">Option 2</div>
                      <div className="px-3 py-2 hover:bg-gray-700 cursor-pointer">Option 3</div>
                    </div>
                  )} */}
                </div>
              </div>
            )}
            {!patchStatus && (
              <div className="flex items-center justify-between mb-4  rounded-lg p-4 h-full w-full">
                <SelectDevice />
              </div>
            )}
          </div>

          {patchStatus && <PatchCenterDashboard />}
        </Card>
      </div>
    </div>
  );
};

export default Outbox;
